import React from "react";
import BPChart from "components/common/chart/bp_chart/BPChart";

import { Grid } from "@mui/material";
import RpmAnalyticFilter from "./RpmAnalyticFilter";

const RpmAnalytic = ({ filter, isLoading, setFilter, data }) => {
  return (
    <div style={{ marginTop: "16px" }}>
      {data ? (
        <>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            style={{ marginBottom: "5px" }}
          >
            <Grid item>
              <h2 style={{ fontSize: "18px" }}>RPM Information</h2>
            </Grid>
            <Grid item>
              <RpmAnalyticFilter filter={filter} setFilter={setFilter} />
            </Grid>
          </Grid>

          <BPChart
            isLoading={isLoading}
            chartTitle="Blood Pressure"
            data={data}
            filter={filter}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RpmAnalytic;
